import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { useSelector } from "react-redux";
import * as utils from "../../Utils/comman";

function BomProcess({
  setIsBomProcess,
  bomList,
  selectedBOM,
  selectedProduct,
  batchSize,
  selectedBatch,
  finalData,
  props,
}) {
  console.log(bomList);
  const CrawMaterials =
    bomList.raw_materials?.filter((bom) => bom.id === selectedBOM) || [];
  const CfinishedGoods =
    bomList.finished_goods?.filter((bom) => bom.id === selectedBOM) || [];
  const consumableItems =
    bomList.consumable_items?.filter((bom) => bom.id === selectedBOM) || [];

  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const parseBatchSize = (batchSize) =>
    parseFloat(batchSize?.replace(/[^\d.]/g, "")) || 0;
  const numericBatchSize = parseBatchSize(batchSize);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [finishedGoods, setFinishedGoods] = useState([]);
  const [consumables, setConsumables] = useState([]);

  useEffect(() => {
    const getFormattedItems = (items, type) => {
      return items?.map((item) => ({
        id: 0,
        itemId: item.itemId || item.ci_itemId || item.fg_itemId,
        item_name: item.item_name || item.ci_item_name || item.fg_item_name,
        item_code: item.item_code || item.ci_item_code || item.fg_item_code,
        qty: item.qty || item.ci_qty || item.fg_qty,
        auto_qty:
          (numericBatchSize * (item.qty || item.ci_qty || item.fg_qty)) / 100,
        actual_qty: "",
        remark: "",
        unit_id: item.unit_id || item.ci_unit_id || item.fg_unit_id,
        unit_name: item.unit_name || item.ci_unit_name || item.fg_unit_name,
        item_type: type,
      }));
    };

    setRawMaterials(getFormattedItems(CrawMaterials, "raw_material"));
    setFinishedGoods(getFormattedItems(CfinishedGoods, "finish_good"));
    setConsumables(getFormattedItems(consumableItems, "consumable_item"));
  }, [props?.rowData, bomList, selectedBOM, numericBatchSize]);

  const handleInputChange = (setItems, index, field, value) => {
    setItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index][field] = value;
      return updatedItems;
    });
  };

  const handleFinalSave = () => {
    const formatItems = (items) =>
      items.map((item) => ({
        id: item.id,
        item_id: item.itemId,
        auto_qty: item.auto_qty,
        actual_qty: item.actual_qty || "",
        remark: item.remark || "",
        unit_id: item.unit_id,
        item_type: item.item_type,
      }));

    const formData = new FormData();
    formData.append("product_id", finalData?.selectedProduct);
    formData.append("batch_no_id", finalData?.selectedBatch);
    formData.append("plant_id", finalData?.selectedPlantLocation);
    formData.append("batch_size", batchSize);
    formData.append("bom_stock_status", finalData?.selectedStatus);
    formData.append("RND_or_process_status", "0");
    formData.append("bom_id", finalData?.selectedBom);
    formData.append(
      "bom_screen",
      JSON.stringify([
        ...formatItems(rawMaterials),
        ...formatItems(finishedGoods),
        ...formatItems(consumables),
      ])
    );

    utils
      .callAPI("post", `/production/process/save`, formData)
      .then(() => {
        props.onChange({ mode: "list" });
      })
      .catch((err) => {});
  };

  const renderTable = (title, items, setItems) => (
    <div className="table-responsive mb-4">
      <h5 className="text-uppercase fw-bold">{title}</h5>
      <RB.Table striped bordered hover>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Auto Qty</th>
            <th>Actual Qty</th>
            <th>Unit</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((item, index) => (
            <tr key={item.itemId}>
              <td>{item.item_code}</td>
              <td>{(parseFloat(item.auto_qty) || 0).toFixed(2)}</td>
              <td>
                <RB.Form.Control
                  type="text"
                  value={item.actual_qty}
                  onChange={(e) =>
                    handleInputChange(
                      setItems,
                      index,
                      "actual_qty",
                      e.target.value
                    )
                  }
                />
              </td>
              <td>{item.unit_name}</td>
              <td>
                <RB.Form.Control
                  type="text"
                  value={item.remark}
                  onChange={(e) =>
                    handleInputChange(setItems, index, "remark", e.target.value)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </RB.Table>
    </div>
  );

  return (
    <RB.Row className="mt-4">
      <RB.Col md={2}>
        <div>
          <span className="text-uppercase fw-bold small text-body-secondary">
            Product Name
          </span>
          <p className="fw-medium text-sm fw-semibold">
            {selectedProduct?.label}
          </p>
        </div>
        <div>
          <span className="text-uppercase fw-bold small text-body-secondary">
            Batch No
          </span>
          <p className="fw-medium text-sm fw-semibold">
            {selectedBatch?.batch_no}
          </p>
        </div>
        <div>
          <span className="text-uppercase fw-bold small text-body-secondary">
            Batch Size
          </span>
          <p className="fw-medium text-sm fw-semibold">{batchSize}</p>
        </div>
        <div>
          <span className="text-uppercase fw-bold small text-body-secondary">
            Operator Name
          </span>
          <p className="fw-medium text-sm fw-semibold">{`${userProfile?.firstName} ${userProfile?.lastName}`}</p>
        </div>
      </RB.Col>

      <RB.Col md={10}>
        {renderTable("Raw Materials", rawMaterials, setRawMaterials)}
        {renderTable("Finished Goods", finishedGoods, setFinishedGoods)}
        {renderTable("Consumables", consumables, setConsumables)}
      </RB.Col>

      <div className="text-end mt-3">
        <RB.Button variant="primary" className="ms-1" onClick={handleFinalSave}>
          Save
        </RB.Button>
      </div>
    </RB.Row>
  );
}

export default BomProcess;
